import React from 'react';
import { styled } from '@compiled/react';
import { token } from '@atlaskit/tokens';
import type { Props } from './types';

const Name = (props: Props) => {
	const { name, avatarUrl } = props;
	return (
		<StyledContainer>
			<Avatar
				src={avatarUrl}
				srcSet={`${avatarUrl}?size=small, ${avatarUrl}?size=large 2x`}
				alt=""
			/>
			<Label>{name}</Label>
		</StyledContainer>
	);
};

export default Name;

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- Ignored via go/DSP-18766
const Label = styled.span({
	marginLeft: token('space.400'),
	overflow: 'hidden',
	textOverflow: 'ellipsis',
});

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- Ignored via go/DSP-18766
const Container = styled.div({
	display: 'flex',
	flex: '1 1 auto',
	flexDirection: 'row',
	width: '100%',
	whiteSpace: 'nowrap',
	overflow: 'hidden',
	textOverflow: 'ellipsis',
	paddingTop: token('space.150'),
	paddingBottom: token('space.150'),
});

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- Ignored via go/DSP-18766
const StyledContainer = styled(Container)({
	alignItems: 'center',
	display: 'flex',
	paddingTop: token('space.100'),
});

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- Ignored via go/DSP-18766
const Avatar = styled.img({
	flexShrink: 0,
	width: token('space.300'),
	height: token('space.300'),
	marginRight: token('space.negative.300'),

	borderRadius: '3px',
	display: 'inline-block',
	verticalAlign: 'middle',
});
